// extracted by mini-css-extract-plugin
module.exports = {"container":"premium-course_container__icBGF","btn":"premium-course_btn__AcUw7"};